<template>
    <CRow>
        <CCol>
            <CCard class="store-card">
                <CCardHeader>
                    <strong>Создание ресторана</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            v-model="restaurant.title"
                            label="Название"
                            placeholder="Введите название ресторана" />
                        <CInput
                            v-model="restaurant.code"
                            label="Код"
                            placeholder="Введите код" />
                        <CInput
                            v-model="restaurant.legal_entity"
                            label="Юр. лицо"
                            placeholder="ООО…" />
                        <CInput v-model="computedCode" type="hidden" />
                        <CInput
                            v-model="restaurant.short_title"
                            label="Короткое название"
                            placeholder="Введите короткое название ресторана" />
                        <CInput
                            v-model="restaurant.alias"
                            label="Алиас"
                            placeholder="Введите алиас" />
                        <CTextarea
                            v-model="restaurant.description"
                            label="Краткое описание"
                            placeholder="Укажите краткое описание (не более 255 символов)" />
                        <CTextarea
                            v-model="restaurant.synonyms"
                            label="Синонимы"
                            placeholder="Укажите синонимы для поиска" />
                        <CInputFile
                            ref="picture"
                            label="Изображение сервиса (мобильное приложение)"
                            horizontal
                            @change="selectPicture" />
                        <br><br>
                        <CInputFile
                            ref="picture"
                            label="Изображение для поиска"
                            horizontal
                            @change="selectSquarePicture" />
                        <CInputFile
                            ref="picture"
                            label="Изображение для доставки"
                            horizontal
                            @change="selectDeliveryPicture" />
                        <br><br>
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (внутри сервиса)"
                            horizontal
                            @change="selectDesktopPicture" />
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (список)"
                            horizontal
                            @change="selectDesktopPictureInList" />
                        <CInput
                            v-model="restaurant.address"
                            label="Адрес для доставки"
                            placeholder="Укажите адрес, которй будет показываться на странице доставки" />
                        <CInput v-model="restaurant.phone" label="Телефон" />
                        <CInput v-model="restaurant.open_at" label="Открывается в" />
                        <CInput v-model="restaurant.close_at" label="Закрывается в" />
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Лейбл</CCol>
                            <CCol sm="9">
                                <CSelect
                                    inline
                                    :value.sync="restaurant.service_label"
                                    :options="services_label"
                                    placeholder="Лейбл..."
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Скрывать когда закрыт
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.hide"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Время доставки
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark" 
                                    shape="pill"
                                variant="opposite"
                                :checked.sync="restaurant.show_delivery_time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">
                            Скрывать рейтинг
                        </CCol>
                        <CCol sm="9">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="restaurant.hide_rating"
                            />
                        </CCol>
                    </CRow>

                        <CInput v-model="restaurant.min_price" label="Минимальный заказ" />
                        <CInput v-model="restaurant.min_price_pickup" label="Минимальная сумма для самовывоза" />

                        <CInput
                            v-model.number="restaurant.weight_limit"
                            label="Ограничение по весу (грамм)" />
                        <CInput
                            v-if="restaurant.weight_limit && restaurant.weight_limit > 0"
                            v-model="restaurant.weight_limit_description"
                            label="Сообщение о превышении веса" />

                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="restaurant.delay_time_hour"
                                    label="Время, необходимое на выполнение заказа (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="restaurant.delay_time"
                                    label="Время, необходимое на выполнение заказа (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="restaurant.delivery_time_hour"
                                    label="Время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="restaurant.delivery_time"
                                    label="Время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="restaurant.max_delivery_time_hour"
                                    label="Максимальное время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="restaurant.max_delivery_time"
                                    label="Максимальное время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <TimeSlotsUpdate :time-slots="timeSlots" @set-timeSlots="setTimeSlots" />
                        <CRow><CCol tag="label" class="col-form-label">Лейблы</CCol></CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Новый сервис
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.is_new_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Веган
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.vegan_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Проверено МИРСИТИ
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.verified_mircity_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Блюдо в подарок
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.dish_gift_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать состав
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.show_additional_info"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать популярное в "профиле"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.popular_profile"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Убрать применение промокода
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.hide_promocode"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Множественные ингридиенты
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.multiple_ingridients"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Считать КБЖУ
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.counting_calories"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать на главной
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.show_main_page"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать популярные блюда в "профиле"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.popular_profile"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Отключить применение тарифов по зонам</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.delivery_zone_disabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.enabled" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create">Создать</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="$router.push('/restaurants')">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import TimeSlotsUpdate from '@/components/TimeSlotsUpdate';
    import { translit } from '@/utils/translit';
    import { xssRegEx } from '@/utils/rules';

    export default {
        name: 'Administrator',
        components: {
            TimeSlotsUpdate,
        },

        data() {
            return {
                schedule: undefined,
                timeSlots: undefined,
                restaurant: {
                    service_label: '',
                    code: '',
                    title: '',
                    short_title: '',
                    alias: '',
                    delivery_terminal_id: '',
                    description: '',
                    synonyms: '',
                    address: '',
                    picture: '',
                    square_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    delivery_picture: '',
                    open_at: '0',
                    close_at: '0',
                    extended_schedule: false,
                    min_price: 0,
                    min_price_pickup: 0,
                    weight_limit: 0,
                    weight_limit_description: '',
                    phone: '',
                    delay_time: 0,
                    delay_time_hour: 0,
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    delivery_zone_disabled: false,
                    enabled: true,
                    hide: false,
                    show_delivery_time: true,
                    hide_rating: false,
                    is_new_label: false,
                    hide_promocode: false,
                    multiple_ingridients: false,
                    counting_calories: false,
                    show_main_page: false,
                    show_in_table_orders: false,
                    popular_profile: false,
                    vegan_label: false,
                    verified_mircity_label: false,
                    show_additional_info: true,
                    dish_gift_label: false,
                    labels: {
                        choose: false,
                        glutenFree: false,
                        halal: false,
                        meatFree: false,
                        new: false,
                        popular: false,
                        post: false,
                        sugarFree: false,
                        vegan: false,
                        spicy: false,
                        recommended: false,
                        newYear: false,
                        friendship: false,
                    },
                    average_bill: 0
                },
                selectedPicture: null,
                selectedSquarePicture: null,
                selectedDesktopPicture: null,
                selectedDesktopPictureInList: null,
            };
        },

        computed: {
            computedCode() {
                this.restaurant.code = translit(this.restaurant.title ? this.restaurant.title : '');
                return this.restaurant.code;
            },
        },

        mounted() {
            if(!this.services_label) {
                const labels = [];
                labels.push({ value: BUSINESS_LABEL.IS_NEW, label: 'Новый сервис' });
                labels.push({ value: BUSINESS_LABEL.VEGAN, label: 'Веган' });
                labels.push({ value: BUSINESS_LABEL.VERIFIED_MIRCITY, label: 'Проверено МИРСИТИ' });
                labels.push({ value: BUSINESS_LABEL.DISH_GIFT, label: 'Блюдо в подарок' });
                labels.push({ value: null, label: 'Без лейбла' });
                this.services_label = labels;
            }
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            setTimeSlots(timeSlots) {
                this.timeSlots = timeSlots;
            },
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectSquarePicture(FileList) {
                this.selectedSquarePicture = FileList[0];
            },
            selectDesktopPicture(FileList) {
                this.selectedDesktopPicture = FileList[0];
            },
            selectDesktopPictureInList(FileList) {
                this.selectedDesktopPictureInList = FileList[0];
            },
            selectDeliveryPicture(FileList) {
                this.selectedDeliveryPicture = FileList[0];
            },

            async create() {
                if (!this.restaurant.code) {
                    this.$root.$emit('showError', 'Укажите код.');
                    return;
                }
                if (!this.restaurant.title) {
                    this.$root.$emit('showError', 'Укажите название ресторана.');
                    return;
                }
                if (!this.restaurant.description) {
                    this.$root.$emit('showError', 'Укажите краткое описание ресторана.');
                    return;
                }
                if (xssRegEx.test(this.restaurant.description)) {
                    this.$root.$emit('showError', 'Описание содержит недопустимые символы.')
                    return
                }
                if (!this.selectedPicture) {
                    this.$root.$emit('showError', 'Выберите картинку ресторана.');
                    return;
                }
                if (!this.restaurant.phone) {
                    this.$root.$emit('showError', 'Укажите номер телефона ресторана.');
                    return;
                }
                if (
                    !this.restaurant.delivery_time &&
                    !this.restaurant.delivery_time_hour
                ) {
                    this.$root.$emit('showError', 'Укажите время доставки.');
                    return;
                }
                if (
                    this.restaurant.delivery_time == 0 &&
                    this.restaurant.delivery_time_hour == 0
                ) {
                    this.$root.$emit('showError', 'Укажите время доставки.');
                    return;
                }

                this.restaurant.hide = !!this.restaurant.hide;
                this.restaurant.show_delivery_time = !!this.restaurant.show_delivery_time;
                this.restaurant.extended_schedule = !!this.restaurant.extended_schedule;
                this.restaurant.hide_rating = !!this.restaurant.hide_rating;
                this.restaurant.is_new_label = !!this.restaurant.is_new_label;
                this.restaurant.hide_promocode = !!this.restaurant.hide_promocode;
                this.restaurant.multiple_ingridients = !!this.restaurant.multiple_ingridients;
                this.restaurant.counting_calories = !!this.restaurant.counting_calories;
                this.restaurant.show_main_page = !!this.restaurant.show_main_page;
                this.restaurant.show_in_table_orders = !!this.restaurant.show_in_table_orders;
                this.restaurant.popular_profile = !!this.restaurant.popular_profile;
                this.restaurant.vegan_label = !!this.restaurant.vegan_label;
                this.restaurant.verified_mircity_label = !!this.restaurant.verified_mircity_label;
                this.restaurant.dish_gift_label = !!this.restaurant.dish_gift_label;
                this.restaurant.timeSlots = this.timeSlots;
                this.restaurant.min_price = this.restaurant.min_price ? +this.restaurant.min_price : 0;
                this.restaurant.min_price_pickup = this.restaurant.min_price_pickup ? +this.restaurant.min_price_pickup : 0;
                this.restaurant.weight_limit = this.restaurant.weight_limit ? +this.restaurant.weight_limit : 0;

                try {
                    let formData = new FormData();

                    if (this.selectedSquarePicture) {
                        formData.append('file', this.selectedSquarePicture);
                        const squarePictureName = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.square_picture = squarePictureName.data.filename;
                    }

                    if (this.selectedDesktopPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPicture);
                        const desktopPictureName = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.desktop_picture = desktopPictureName.data.filename;
                    }

                    if (this.selectedDesktopPictureInList) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPictureInList);
                        const desktopPictureName = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.desktop_picture_list = desktopPictureName.data.filename;
                    }

                    if (this.selectedDeliveryPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDeliveryPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.delivery_picture = uploadPicture.data.filename;
                    }

                    formData = new FormData();
                    formData.append('file', this.selectedPicture);

                    const uploadPicture = await Vue.axios.post('/files/upload', formData);
                    this.restaurant.picture = uploadPicture.data.filename;
                    this.restaurant.schedule = this.schedule;
                    this.restaurant.delay_time = this.restaurant.delay_time ? +this.restaurant.delay_time : 0;
                    this.restaurant.delay_time_hour = this.restaurant.delay_time_hour ? +this.restaurant.delay_time_hour : 0;
                    this.restaurant.delivery_time = this.restaurant.delivery_time ? +this.restaurant.delivery_time : 0;
                    this.restaurant.delivery_time_hour = this.restaurant.delivery_time_hour ? +this.restaurant.delivery_time_hour : 0;
                    this.restaurant.max_delivery_time = this.restaurant.max_delivery_time ? +this.restaurant.max_delivery_time : null;
                    this.restaurant.max_delivery_time_hour = this.restaurant.max_delivery_time ? +this.restaurant.max_delivery_time_hour : null;

                    const newRestaurant = await Vue.axios.post('/restaurants/create', this.restaurant);

                    this.$router.push({
                        path: '/restaurants/' + newRestaurant.data.id,
                    });
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка сохранения. \n\n${error.response.data.error}`);
                }
            },

            goBack() {
                this.$router.push({ path: '/restaurants' });
            },
        },
    };
</script>
